import { lang } from '../../assets/lang'

const instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

const typesFb = [
  { key: 'new_post_back', value: lang.button_html_types_postback_new },
  { key: 'post_back', value: lang.button_html_types_postback },
  { key: 'web_url', value: lang.button_html_types_web_url },
  { key: 'web_url_full', value: lang.button_html_types_web_url_full },
  { key: 'web_url_compact', value: lang.button_html_types_web_url_compact },
  { key: 'web_url_tall', value: lang.button_html_types_web_url_tall },
  { key: 'phone_number', value: lang.button_html_types_phone_number },
  { key: 'system_default', value: lang.button_html_types_system_default },
]

const typesIg = [
  { key: 'new_post_back', value: lang.button_html_types_postback_new },
  { key: 'post_back', value: lang.button_html_types_postback },
  { key: 'web_url', value: lang.button_html_types_web_url },
  { key: 'web_url_birthday', value: lang.button_html_types_web_url_birthday },
  { key: 'web_url_email', value: lang.button_html_types_web_url_email },
  { key: 'web_url_phone', value: lang.button_html_types_web_url_phone },
  { key: 'web_url_location', value: lang.button_html_types_web_url_location },
]

export const types = instagram_bot_addon ? typesIg : typesFb

